import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentStatusEnum } from '../../../../../models';
import { PartnerSettingsMenuLevel3Enum } from '../../partner-settings-root/partner-settings-root.component';

@Component({
    selector: 'partner-settings-legal-document-status',
    templateUrl: './partner-settings-legal-document-status.component.html',
    styleUrls: ['./partner-settings-legal-document-status.component.scss']
})

export class PartnerSettingsLegalDocumentStatusComponent {
    constructor(private messageService: MessageService) {
    }

    @Input()
    public onHide: () => void = () => { };

    @Input()
    public visible: boolean = false;

    @Input()
    public activeDocumentItem: PartnerSettingsMenuLevel3Enum = PartnerSettingsMenuLevel3Enum.None;

    public document: any = {};

    public documentTypeEnum = PartnerSettingsMenuLevel3Enum;
    public documentStatusEnum = DocumentStatusEnum;

    public showDocumentStatus: boolean = false;

    public handleHideDocumentStatus() {
        this.onHide();
    }

}
